import { useEffect, useState } from "react";
import { format, parseISO } from "date-fns";
import { ro } from "date-fns/locale";
import { api } from "@/lib/api";
import { lastName } from "@/lib/constants";

let accessP = null;
export function useReportsAccess() {
  const [a, setA] = useState(null);
  useEffect(() => {
    accessP = accessP || api.get("/social/access").then((r) => r.data).catch(() => ({ allowed: false }));
    accessP.then(setA);
  }, []);
  return a;
}
export const resetReportsAccess = () => { accessP = null; };

export const PF = {
  facebook: { label: "Facebook", short: "FB", color: "#1877F2", icon: "📘" },
  instagram: { label: "Instagram", short: "IG", color: "#E1306C", icon: "📸" },
  tiktok: { label: "TikTok", short: "TT", color: "#111111", icon: "🎵" },
};
export const DECK_THEMES = [["luminos", "Luminos"], ["intunecat", "Întunecat"], ["liquid", "Liquid Glass"], ["liquid_dark", "Liquid Glass întunecat"]];
export const PERIODS = [["week", "7 zile"], ["month", "30 zile"], ["this_month", "Luna asta"], ["last_month", "Luna trecută"], ["day", "Azi"], ["yesterday", "Ieri"], ["custom", "Alege perioada"]];

export const n = (v) => (v == null ? "—" : v >= 1e6 ? `${(v / 1e6).toFixed(1)}M` : v >= 1e4 ? `${Math.round(v / 1e3)}k` : v >= 1e3 ? `${(v / 1e3).toFixed(1)}k` : String(v));
export const delta = (v) => (v == null ? "" : v > 0 ? `+${n(v)}` : v < 0 ? `−${n(-v)}` : "0");
export const pct = (cur, prev) => (prev ? Math.round(((cur - prev) / prev) * 100) : null);
export const dd = (d) => format(parseISO(d), "d MMM", { locale: ro });
export const rangeLabel = (r) => (r.start === r.end ? dd(r.start) : `${dd(r.start)} – ${dd(r.end)}`);

export function reportWhatsApp(r, link) {
  const out = [`📊 *RAPORT SOCIAL MEDIA${r.scope_name ? ` · ${(r.scope === "client" ? lastName(r.scope_name) : r.scope_name).toUpperCase()}` : ""}*`, `_${rangeLabel(r)}_`];
  const all = r.clients.reduce((a, c) => ({ views: a.views + c.totals.views, likes: a.likes + c.totals.likes, posts: a.posts + c.totals.posts }), { views: 0, likes: 0, posts: 0 });
  out.push(`> 🎬 *${all.posts}* postări · 👁 *${n(all.views)}* vizualizări · ❤️ *${n(all.likes)}*`);
  if (r.clients.length > 1) {
    out.push("", "🏆 *CLASAMENT*");
    r.clients.forEach((c) => {
      const d = c.prev_rank ? c.prev_rank - c.rank : null;
      const mv = d == null ? "🆕" : d > 0 ? `⬆️${d}` : d < 0 ? `⬇️${-d}` : "➖";
      out.push(`${c.rank}. *${lastName(c.client.name)}* · ${n(c.totals.views)} 👁 ${mv}`);
    });
  }
  r.clients.forEach((c) => {
    out.push("", `👤 *${lastName(c.client.name).toUpperCase()}*`);
    const g = Object.entries(c.growth).map(([p, x]) => `${PF[p].short} ${n(x.followers)}${x.new ? ` (${delta(x.new)})` : ""}`).join(" · ");
    if (g) out.push(`👥 ${g}`);
    const ch = pct(c.totals.views, c.prev.views);
    out.push(`🎬 ${c.totals.posts} postări · 👁 ${n(c.totals.views)} · ❤️ ${n(c.totals.likes)} · 💬 ${n(c.totals.comments)}${ch != null ? ` · ${ch >= 0 ? "📈" : "📉"} ${ch}%` : ""}`);
    c.top.forEach((p, i) => out.push(`${["🥇", "🥈", "🥉"][i]} \`${PF[p.platform].short}\` ${n(p.views)} 👁 · ${n(p.likes)} ❤️ — ${p.url}`));
  });
  if (link) out.push("", `🔗 Raportul complet: ${link}`);
  return out.join("\n");
}

export async function reportCanvas(r) {
  const W = 1080, pad = 60, rows = r.clients.reduce((a, c) => a + 3 + c.top.length, 0);
  const cv = document.createElement("canvas");
  cv.width = W; cv.height = 260 + rows * 46 + r.clients.length * 40;
  const x = cv.getContext("2d");
  x.fillStyle = "#0B0D13"; x.fillRect(0, 0, W, cv.height);
  x.fillStyle = "#F59E0B"; x.font = "bold 54px sans-serif"; x.fillText("Raport social media", pad, 100);
  x.fillStyle = "#A1A1AA"; x.font = "30px sans-serif"; x.fillText(`${r.scope_name || "Toți clienții"} · ${rangeLabel(r)}`, pad, 150);
  let y = 230;
  r.clients.forEach((c) => {
    x.fillStyle = c.client.color || "#F59E0B"; x.fillRect(pad, y - 30, 8, 36);
    x.fillStyle = "#FAFAFA"; x.font = "bold 38px sans-serif"; x.fillText(lastName(c.client.name), pad + 24, y); y += 50;
    x.font = "28px sans-serif"; x.fillStyle = "#D4D4D8";
    x.fillText(Object.entries(c.growth).map(([p, g]) => `${PF[p].label} ${n(g.followers)} ${g.new ? delta(g.new) : ""}`).join("   ") || "Fără conturi", pad + 24, y); y += 44;
    x.fillText(`${c.totals.posts} postări · ${n(c.totals.views)} vizualizări · ${n(c.totals.likes)} like-uri · ${n(c.totals.comments)} comentarii`, pad + 24, y); y += 46;
    x.fillStyle = "#A1A1AA"; x.font = "26px sans-serif";
    c.top.forEach((p, i) => { x.fillText(`${i + 1}. ${PF[p.platform].label}: ${n(p.views)} vizualizări · ${n(p.likes)} like-uri · ${(p.caption || "").slice(0, 38)}`, pad + 24, y); y += 46; });
    y += 40;
  });
  return cv;
}
